<div class="tw-relative tw-flex tw-flex-col tw-gap-8 tw-bg-gray-75 tw-rounded-tl-5 tw-rounded-tr-5 tw-px-4 tw-pt-6 tw-pb-10 tw-font-body"
  appKeyboardInset>
  <div class="tw-absolute tw-top-3 tw-right-3 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center" (click)="closeBottomSheet()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-800" [iconName]="'close'"></cs-icon>
  </div>
  <div class="tw-flex tw-flex-col tw-gap-6">
    <div class="tw-flex tw-flex-col tw-gap-1">
      <div class="tw-font-lexend tw-font-bold tw-text-600 tw-text-gray-800" i18n="@@shareYourFeedback">Share your feedback</div>
      <div class="tw-font-body tw-font-medium tw-text-300 tw-text-gray-500" i18n="@@shareFeedbackSubtitle">
        Tell us what you were not able to understand
      </div>
    </div>
    <textarea
      #feedbackInput
      class="tw-h-32 tw-w-full tw-resize-none tw-rounded-3 tw-border-0 tw-bg-gray-100 tw-p-4 tw-font-body tw-text-300 tw-text-gray-800 tw-outline-none"
      placeholder="Write here"
      i18n-placeholder="@@writeHere"
      [(ngModel)]="feedbackValue"></textarea>
  </div>
  <button
    data-keyboard-cta
    class="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-3 tw-bg-teal-600 tw-font-lexend tw-text-500 tw-font-semibold tw-text-white"
    [ngClass]="{ 'tw-opacity-50 tw-pointer-events-none': !feedbackValue.trim() || submitting }"
    (click)="submit()"
    i18n="@@submit">Submit</button>
</div>
